<template ref="uploadImage">
  <div class="finish_room">
    <div class="finish_room2">
      <div :images="photo">
        <div :key="index" v-for="(item, index) in photo" class="room_img">
          <img v-lazy="typeof item == 'string' ? item : item" />
          <div v-if="!disabled" @click="deleteImg(index)" class="im-button">
            <div class="im-close"></div>
            <div class="im-close1"></div>
          </div>
        </div>
      </div>
      <div v-if="photo.length < limit" v-loading="loading" class="room_add_img">
        <span style="margin-top: 35px"
          ><img src="../assets/add_img.png"
        /></span>
        <input :disabled="disabled" @change="add_img" type="file" />
      </div>
    </div>
  </div>
</template>

<template>
  <div class="finish_room">
    <div class="finish_room2">
      <div v-for="(item, index) in photo" :key="index" class="room_img">
        <img :src="item" />
        <div v-if="!disabled" @click="deleteImg(index)" class="im-button">
          <div class="im-close"></div>
          <div class="im-close1"></div>
        </div>
      </div>

      <div v-if="photo.length < limit" v-loading="loading" class="room_add_img">
        <img src="../assets/add_img.png" />
        <input :disabled="disabled" type="file" @change="add_img" />
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  props: {
    value: { type: String, default: "" },
    limit: { type: Number, default: 1 },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      photo: [],
      loading: false,
    };
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.photo = val ? [val] : [];
      },
    },
    photo() {
      this.$emit("input", this.photo[0] || "");
    },
  },
  methods: {
    deleteImg() {
      this.photo = [];
      this.$emit("input", "");
      // 删除图片时，清空二维码内容
      this.$emit("change", { qr_image: "", qr_code: "" });
    },
    add_img(e) {
      const file = e.target.files[0];
      if (!file) return;

      const form = new FormData();
      form.append("file", file);

      this.loading = true;
      axios.post("/upload/uploadImage", form).then((res) => {
        this.loading = false;
        if (res.data.code === 0) {
          const responseData = res.data.data || {};
          
          // 获取图片路径（后端返回 image_url，统一映射为 qr_image）
          const imagePath = responseData.image_url || responseData.qr_image || responseData.image || (typeof responseData === 'string' ? responseData : "") || "";
          
          // 获取二维码解析内容（确保字段名正确）
          const qrCode = responseData.qr_code || responseData.code || "";
          
          // 通过 v-model 传递图片路径
          this.photo = [imagePath];
          
          // 发出 change 事件，统一使用 qr_image 字段名
          this.$emit("change", {
            qr_image: imagePath,
            qr_code: qrCode
          });
        }
      }).catch((error) => {
        this.loading = false;
        console.error("上传失败:", error);
      });
    },
  },
};
</script>

<style>
.finish_room {
  /*width: 140px;*/
  /*height: 165px;*/
}

img {
  height: 100%;
}

.finish_room2 {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  flex-flow: wrap;
}

.finish_room2 > div {
  display: flex;
  flex-wrap: wrap;
}

.finish_room2 .margeImg {
  margin-left: 10px;
}

.finish_room2 .room_img {
  width: 100px;
  height: 100px;
  cursor: pointer;
  overflow: hidden;
  position: relative;
  text-align: center;
  background-color: rgba(0, 0, 0, 0.5);
  margin-left: 10px;
  margin-top: 10px;
}

.finish_room2 .room_img:before {
  /*content: "";*/
  /*width: 0;*/
  /*height: 100%;*/
  /*!*background: #000;*!*/
  /*padding: 14px 18px;*/
  /*position: absolute;*/
  /*top: 0;*/
  /*left: 50%;*/
  /*opacity: 0;*/
}

.finish_room2 .room_img:hover:before {
  width: 100%;
  left: 0;
  opacity: 0.5;
}

.finish_room2 .room_img .box-content {
  width: 100%;
  padding: 14px 18px;
  color: #fff;
  position: absolute;
  top: 38%;
  left: 0;
}

.finish_room2 .room_img .icon {
  padding: 0;
  margin: 0;
  list-style: none;
  margin-top: -20px;
}

.finish_room2 .room_img .icon li {
  display: inline-block;
}

.finish_room2 .room_img .icon li i {
  display: block;
  width: 40px;
  height: 40px;
  line-height: 40px;
  border-radius: 50%;
  font-size: 20px;
  font-weight: 700;
  color: #fff;
  margin-right: 25px;
  opacity: 0;
  transform: translateY(50px);
  transition: all 0.5s ease 0s;
}

@media only screen and (max-width: 990px) {
  .finish_room2 .room_img {
  }
}

.finish_room2 .deleteImg {
  color: red;
  position: absolute;
  top: 0px;
  left: 80px;
  cursor: pointer;
}

.finish_room2 .room_img img {
  cursor: pointer;
  width: 100px;
  height: 100px;
}

.finish_room2 > .room_img span {
  position: absolute;
  width: auto;
  height: auto;
  right: 5px;
  bottom: 3px;
}

.finish_room2 .im-button {
  position: absolute;
  top: -14px;
  right: -18px;
  width: 40px;
  height: 40px;
  cursor: pointer;
  border-radius: 50%;
  background-color: rgba(0, 0, 0, 0.5);
  opacity: 0;
}

.finish_room2 .room_img:hover .icon li i {
  opacity: 0.5;
}

.finish_room2 .room_img:hover img {
  opacity: 0.5;
}

.finish_room2 .room_img:hover .im-button {
  opacity: 1;
}

.finish_room2 .im-close {
  transform: rotate(-45deg);
  line-height: 0px;
  left: 6px;
  bottom: 13px;
  display: inline-block;
  width: 15px;
  height: 2px;
  background: #fff;
  position: absolute;
}

.finish_room2 .im-close1 {
  left: 5px;
  bottom: 13px;
  display: inline-block;
  width: 15px;
  height: 2px;
  background: #fff;
  position: absolute;
  transform: rotate(45deg);
}

.room_add_img {
  margin-left: 10px;
  margin-top: 10px;
  width: 100px;
  height: 100px;
  cursor: pointer;
  border: 1px solid #e1e1e1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  position: relative;
  z-index: 10;
}

.room_add_img > span:nth-child(1) {
  width: 30px;
  height: 30px;
  overflow: hidden;
}

.room_add_img > span:nth-child(2) {
  margin-bottom: 10px;
}

.room_add_img input {
  cursor: pointer;
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  z-index: 99999;
  opacity: 0;
}
</style>
